import { Case, OutcomeType } from '@/api/apis/case';
import { Uuid } from '@/api/types';
import { isRandomizationScs } from '@/utils/helpers';

const reallocationOutcomes = [OutcomeType.DryRun, OutcomeType.Turndown];

export const getCasesAvailableForReallocation = (
  cases: Case[] | undefined,
  initialReallocationCaseId?: Uuid | null,
): Case[] => {
  if (!cases) return [];
  return cases.filter((c) => {
    const hasCorrectOutcome = c.outcomeData && reallocationOutcomes.includes(c.outcomeData.outcomeType);
    const isScsTurndown = isRandomizationScs(c.randomization) && c.outcomeData?.outcomeType === OutcomeType.Turndown;
    const initiallyReallocated = c.caseId === initialReallocationCaseId;
    return hasCorrectOutcome && !isScsTurndown && (!c.reAllocatedToCaseId || initiallyReallocated);
  });
};

export const INFO_MESSAGES_IS_TRIAL_REFERENCE_CASE =
  'Ensure that all inherited fields are consistent with the reference case. Please be aware the trial cases randomized to SCS shall not be available for reallocation';

export const INFO_MESSAGES_IS_RELLOCATION_CASE =
  'Ensure that all inherited fields are consistent with the reference case.';
